import React, { useEffect, useState } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import Icon from "../Icon/Icon";
import Styles from "./Tooltip.module.scss";
import "./Border.css";
import "react-tooltip/dist/react-tooltip.css";
import classNames from "classnames";

interface Props {
  id: string;
  tooltip: string | React.ReactElement;
  variant?: "dark" | "light" | "success" | "warning" | "error" | "info";
  className?: string;
  iconSize?: string;
}

const Tooltip = ({ id, tooltip, variant = "light", className, iconSize = "18px" }: Props) => {
  const [width, setWidth] = useState("100%");

  const calcWidth = () => {
    const width = window.innerWidth;
    width < 500 && setWidth(`${width}px`);
  };

  useEffect(() => {
    calcWidth();
    window.addEventListener("resize", calcWidth);
    return () => window.removeEventListener("resize", calcWidth);
  }, []);

  const anchor = `${id}_tooltip`;
  return (
    <>
      <Icon
        id={anchor}
        name={"infoIconPlain"}
        size={iconSize}
        className={classNames(Styles.icon, className)}
        tabIndex={-1}
      />
      <ReactTooltip anchorSelect={`#${anchor}`} variant={variant} className={Styles.tooltip} style={{ width }}>
        {tooltip}
      </ReactTooltip>
    </>
  );
};

export default Tooltip;
